// auth.interceptor.ts
import { HttpInterceptorFn, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './auth.service';
import { tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const toastr = inject(ToastrService);

  // Attach headers from storage
  const h = auth.getHeaders();
  if (h) {
    req = req.clone({
      setHeaders: {
        'access-token': h['access-token'] ?? '',
        client: h.client ?? '',
        uid: h.uid ?? '',
        expiry: h.expiry ?? '',
        'token-type': h['token-type'] ?? ''
      }
    });
  }

  return next(req).pipe(
    tap(event => {
      // If response returned new tokens, persist them
      if (event instanceof HttpResponse) {
        auth.storeHeadersFromResponse(event);
      }
    }),
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        toastr.error('Uw sessie is verlopen. Log opnieuw in.');
        auth.clearHeaders();
        router.navigate(['/login']);
      }
      return throwError(() => err);
    })
  );
};
